/* eslint-disable comma-dangle */
import type { FC, ReactNode } from 'react';
import { useEffect, useLayoutEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { setAbTests } from 'data/actions/abTests';
import { setQueryUserCountry, setQueryUserId } from 'data/actions/user';

import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

interface IABTestProvider {
  children: ReactNode;
}

export const IS_MOBILE_KEY = 'isMobile';

export const ABTestProvider: FC<IABTestProvider> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const queryAbTest = searchParams.get('abTest');
  const queryUserId = searchParams.get('userId');
  const isAutoTestFromCookies = searchParams.get(LOCAL_STORAGE_KEYS.IS_AUTO_TEST);
  const queryUserCountry = searchParams.get(LOCAL_STORAGE_KEYS.USER_COUNTRY);

  const isAutoTest = !!localStorage.getItem(LOCAL_STORAGE_KEYS.IS_AUTO_TEST);

  const abTestCookie = document?.cookie
    ?.split('; ')
    ?.find((row) => row.startsWith('abTest='))
    ?.split('=')[1];

  useEffect(() => {
    if (isAutoTestFromCookies === 'true') {
      localStorage.setItem(LOCAL_STORAGE_KEYS.IS_AUTO_TEST, isAutoTestFromCookies);
    }
  }, [isAutoTestFromCookies]);

  useEffect(() => {
    if (searchParams.get(IS_MOBILE_KEY) === 'true') {
      localStorage.setItem(LOCAL_STORAGE_KEYS.IS_MOBILE, 'true');
    }
  }, [searchParams]);

  useLayoutEffect(() => {
    if (queryUserId) {
      dispatch(setQueryUserId(queryUserId));
    }

    if (queryUserCountry) {
      dispatch(setQueryUserCountry(queryUserCountry));
    }

    if (abTestCookie && !isAutoTest && isAutoTestFromCookies !== 'true') {
      try {
        const parsed = JSON.parse(abTestCookie);
        dispatch(setAbTests(parsed));
        // console.log('Using abTest from cookie:', { parsed });
      } catch (error) {
        console.log('Error parsing abTest cookie:', { error });
      }
    } else if (queryAbTest && !isAutoTest && isAutoTestFromCookies !== 'true') {
      try {
        const decoded = atob(queryAbTest);
        const parsed = JSON.parse(decoded);
        dispatch(setAbTests(parsed));
        // console.log('Using abTest from URL:', { parsed });
      } catch (error) {
        console.log('Error parsing abTest from URL:', { error });
      }
    }
  }, [abTestCookie, queryAbTest, queryUserId, dispatch, isAutoTest, isAutoTestFromCookies, queryUserCountry]);

  return children;
};

/* eslint-enable comma-dangle */
